module.exports = {
    "Clear search": `Limpar pesquisa`
};


//# sourceMappingURL=pt-PT.main.js.map
